import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2DefinitionIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 45 24.126",
    fill: color,
    children: /*#__PURE__*/jsx("path", {
      d: "M41.112 7.775H3.887a3.762 3.762 0 01-2.745-1.131A3.731 3.731 0 010 3.887a3.743 3.743 0 011.143-2.745A3.743 3.743 0 013.888-.001h37.224a3.743 3.743 0 012.745 1.143A3.743 3.743 0 0145 3.887a3.731 3.731 0 01-1.143 2.757 3.762 3.762 0 01-2.745 1.131zm0 16.351H3.887a3.743 3.743 0 01-2.745-1.143A3.743 3.743 0 010 20.238a3.731 3.731 0 011.143-2.757 3.762 3.762 0 012.745-1.131h37.224a3.762 3.762 0 012.745 1.131A3.731 3.731 0 0145 20.238a3.743 3.743 0 01-1.143 2.745 3.743 3.743 0 01-2.745 1.142z"
    })
  });
};

export { PM2DefinitionIcon };
//# sourceMappingURL=definition.js.map
